"use client";
import { ThreeDMarquee } from "@/components/ui/3d-marquee";
import { DashboardPreview } from "@/components/ui/dashboard-animation";

export default function ThreeDMarqueeDemo() {
  const items = [
    <DashboardPreview key="1" sectionId="overview" />,
    <DashboardPreview key="2" sectionId="links" />,
    <DashboardPreview key="3" sectionId="qr" />,
    <DashboardPreview key="4" sectionId="bio" />,
    <DashboardPreview key="5" sectionId="products" />,
    <DashboardPreview key="6" sectionId="referrals" />,
    <DashboardPreview key="7" sectionId="forms" />,
    <DashboardPreview key="8" sectionId="team" />,
    <DashboardPreview key="9" sectionId="analytics" />,
    <DashboardPreview key="10" sectionId="links" />,
    <DashboardPreview key="11" sectionId="qr" />,
    <DashboardPreview key="12" sectionId="bio" />,
  ];

  return (
    <div className="relative w-full h-full">
      <ThreeDMarquee items={items} />
    </div>
  );
}
